module.exports = __webpack_public_path__ + "/images/monitorizacion-precios-wishlist-BR.87df2af.webp";